import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { TruthSection } from '../components/TruthSection';
import { Benefits } from '../components/Benefits';
import { HowItWorks } from '../components/HowItWorks';
import { WhatsIncluded } from '../components/WhatsIncluded';
import { ForWhom } from '../components/ForWhom';
import { ReviewsCarousel } from '../components/ReviewsCarousel';
import { Offer } from '../components/Offer';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-brand-cream font-sans selection:bg-brand-green selection:text-white" data-id="element-280">
      <Hero data-id="element-281" />
      <PainPoints data-id="element-282" />
      <TruthSection data-id="element-283" />
      <Benefits data-id="element-284" />
      <HowItWorks data-id="element-285" />
      <WhatsIncluded data-id="element-286" />
      <ForWhom data-id="element-287" />
      <ReviewsCarousel data-id="element-288" />
      <Offer data-id="element-289" />
      <FAQ data-id="element-290" />
      <FinalCTA data-id="element-291" />
      <Footer data-id="element-292" />
      <StickyCTA data-id="element-293" />
      <SocialProofPopup data-id="element-294" />
    </main>;
}